import { VibrateIcon } from '@/assets/icons';
import { SettingsItem } from './components/settings-item';
import { dataSettingsRoutes } from './data-settings-routes';
import styles from './settings-list.module.scss';
import { Typography } from '@/ui-kit';
import { useEffect, useState } from 'react';
import { useVibration } from '@/store/useVibration';
// @ts-ignore
import Switch from 'react-ios-switch';
import { useTranslation } from 'react-i18next';

export const SettingsList = () => {
    const { isVibrationEnabled, setVibrationEnabled } =
        useVibration(state => state);

    const { t } = useTranslation();
    
    return (
        <div className={styles.settingsList}>
            {dataSettingsRoutes.map((item) => {
                const IconComponent = item.icon;
                return (
                    <SettingsItem
                        key={item.value}
                        path={item.path}
                        icon={
                            <IconComponent width={28} height={28} />
                        }
                        title={t(item.translationKey)} />
                );
            })}
            <div className={styles.settingsItemAction}>
                <VibrateIcon width={28} height={28} />
                <Typography
                    className={styles.settingsItemActionText}
                    typeColor="black"
                    fontFamily="SFProText">
                    {t('profile.sounds_and_notifications')}
                </Typography>
                <Switch
                    className={styles.settingsItemActionTrailing}
                    checked={isVibrationEnabled}
                    handleColor="#fff"
                    offColor="#E5E5EA"
                    onColor="#F26A1C"
                    style={{
                        minWidth: '50px'
                    }}
                    onChange={async (checked: boolean) => {
                        setVibrationEnabled(checked)
                        localStorage.setItem('VIBRATION_ENABLED', checked.toString())
                    }} />
            </div>
        </div>
    );
};
